import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

function SrPartnerList({ children, singleRow, twoColumns }) {
  return (
    <div className={classnames('SrPartnerList', { singleRow, twoColumns })}>
      {children}
    </div>
  );
}

SrPartnerList.propTypes = {
  children: PropTypes.node.isRequired,
  singleRow: PropTypes.bool,
};

SrPartnerList.displayName = 'SrPartnerList';

export default SrPartnerList;
